export const botName = window.ENV.TELEGRAM_BOT;

export const webAppName = () => {
    if (botName === 'dev_tempSpodialBot') {
        return 'devMarket';
    } else return 'spodialMarket';
};
